import React from 'react';

import { IBRNRepairItemBasic } from '../../declarations';
import StatusBadge, { IStatusBadgeProps } from '../common/StatusBadge';

import './SellerResponseRepairItemStyle.less';

export interface ISellerResponseRepairItemProps {
  brnRepairItem: IBRNRepairItemBasic;
}

const STATUS_MAP: { [key in IBRNRepairItemBasic['response']]: IStatusBadgeProps['status'] } = {
  credit: 'credit',
  fix: 'repair',
  reject: 'denied',
};

export default class SellerResponseRepairItem extends React.PureComponent<
  ISellerResponseRepairItemProps
> {
  public render(): JSX.Element {
    const { brnRepairItem } = this.props;

    const badgeStatus = STATUS_MAP[brnRepairItem.response];

    return (
      <div className="resale-closing-dashboard-seller-response-repair-item">
        <div className="row seller-response-repair-info">
          <div className="col-lg-9 col-xs-12 seller-repair-description">
            {brnRepairItem.description}
          </div>
          <div className="col-lg-3 col-xs-12 seller-repair-badge">
            {badgeStatus && <StatusBadge status={badgeStatus} />}
          </div>
        </div>
      </div>
    );
  }
}
